module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statement"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("亲爱的客户您好：")]), _vm._v(" "), (_vm.isShow == 2) ? _c('div', [_c('div', {
    staticClass: "txt"
  }, [_vm._v("\n        为增强企业账户的安全性，在创建企业账号前需要您先进行个人实名认证核实您的个人身份。我们将采取人脸识别，银行卡认证和手机认证的方式来验证您的本人身份，您的个人信息将得到绝对的保护。\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.isShow == 3) ? _c('div', [_c('div', {
    staticClass: "txt"
  }, [_vm._v("\n        为核实您的个人身份，确保您加入正确的企业，在加入企业前需要您先进行个人实名认证。我们将采取人脸识别，银行卡认证和手机认证的方式来验证您的本人身份，您的个人信息将得到绝对的保护。\n      ")])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('Button', {
    staticClass: "next-btn",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('div', {
    staticClass: "decs"
  }, [_vm._v("\n      注：e签宝向您提供人脸识别服务并承担责任\n    ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert"
  }, [_vm._v("\n      温馨提示：\n      "), _c('div', {
    staticClass: "txt txt1"
  }, [_vm._v("\n        如实名认证过程中存在特殊情况，可联系客服 13818696732进行解决\n      ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2cf417dd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cf417dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/new-register/statement.vue
// module id = 1304
// module chunks = 61